import { useState } from 'react';
import './CambiarContrasena.css';
import { getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import Alert from '../../components/Alert/Alert';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import NavInf from '../../components/NavInf/NavInf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default function CambiarContrasena() {
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
    });

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);
    const [alerta, setAlerta] = useState(null);

    const passwordValidation = {
        hasLetter: /[a-zA-Z]/.test(formData.newPassword),
        hasNumberOrSymbol: /[\d\W]/.test(formData.newPassword),
        hasMinLength: formData.newPassword.length >= 10,
    };

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();

        if (!formData.oldPassword || !formData.newPassword || !formData.repeatPassword) {
            setAlerta({ type: 'error', message: 'Completa todos los campos' });
            return;
        }

        if (formData.newPassword !== formData.repeatPassword) {
            setAlerta({ type: 'error', message: 'Las contraseñas no coinciden' });
            return;
        }

        if (!passwordValidation.hasLetter || !passwordValidation.hasNumberOrSymbol || !passwordValidation.hasMinLength) {
            setAlerta({ type: 'error', message: 'La nueva contraseña no cumple con los requisitos' });
            return;
        }

        try {
            const auth = getAuth();
            const user = auth.currentUser;

            if (!user) {
                setAlerta({ type: 'error', message: 'No hay usuario autenticado' });
                return;
            }

            const cred = EmailAuthProvider.credential(user.email, formData.oldPassword);
            await reauthenticateWithCredential(user, cred);
            await updatePassword(user, formData.newPassword);

            setAlerta({ type: 'success', message: 'Contraseña actualizada exitosamente', redirecTo: '/profile' });
            setFormData({ oldPassword: '', newPassword: '', repeatPassword: '' });
        } catch (err) {
            console.error(err);
            setAlerta({ type: 'error', message: 'Error al cambiar la contraseña. Verifica los datos.' });
        }
    };

    return (
        <>
            <Header minimal={true} searchBar={true} backOn={true} />
            <div className="cambiar-pass-container">
                <form className="cambiar-pass-form" onSubmit={handleChangePassword}>
                    <h2>Cambiar contraseña</h2>
                    <p className='p-sup'>Para cambiar tu contraseña, ingresa tu contraseña actual y la nueva.</p>
                    
                    <label htmlFor="oldPassword">Ingrese su contraseña actual</label>
                    <div className="input-wrapper">
                        <input
                            type={showOld ? 'text' : 'password'}
                            name="oldPassword"
                            value={formData.oldPassword}
                            onChange={handleChange}
                            placeholder="Contraseña actual"
                        />
                        <span className="toggle-pass" onClick={() => setShowOld(!showOld)}>
                            <FontAwesomeIcon icon={showOld ? faEyeSlash : faEye} />
                        </span>
                    </div>

                    <label htmlFor="newPassword">Ingrese su nueva contraseña</label>
                    <div className="input-wrapper">
                        <input
                            type={showNew ? 'text' : 'password'}
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            placeholder="Nueva contraseña"
                        />
                        <span className="toggle-pass" onClick={() => setShowNew(!showNew)}>
                            <FontAwesomeIcon icon={showNew ? faEyeSlash : faEye} />
                        </span>
                    </div>

                    <label htmlFor="repeatPassword">Repita su nueva contraseña</label>
                    <div className="input-wrapper">
                        <input
                            type={showRepeat ? 'text' : 'password'}
                            name="repeatPassword"
                            value={formData.repeatPassword}
                            onChange={handleChange}
                            placeholder="Repita la contraseña"
                        />
                        <span className="toggle-pass" onClick={() => setShowRepeat(!showRepeat)}>
                            <FontAwesomeIcon icon={showRepeat ? faEyeSlash : faEye} />
                        </span>
                    </div>

                    <div className="contraseña-validacion">
                        <p className={passwordValidation.hasLetter ? 'valid' : 'invalid'}>
                            {passwordValidation.hasLetter ? '✔' : ''} Al menos 1 letra
                        </p>
                        <p className={passwordValidation.hasNumberOrSymbol ? 'valid' : 'invalid'}>
                            {passwordValidation.hasNumberOrSymbol ? '✔' : ''} Número o carácter especial
                        </p>
                        <p className={passwordValidation.hasMinLength ? 'valid' : 'invalid'}>
                            {passwordValidation.hasMinLength ? '✔' : ''} Mínimo 10 caracteres
                        </p>
                    </div>

                    <button type="submit">Actualizar</button>
                    {alerta && <Alert type={alerta.type} message={alerta.message} redirectTo={alerta.redirecTo} />}
                </form>
            </div>
            <NavInf />
            <Footer />
        </>
    );
}
